import React, {FC, ReactNode} from "react"
import {formatTextTestIds} from "@next/utils"
import TileImage from "../TileImage"
import {TileCardMedia} from "../../components"
import {SlideDetail} from "../../helpers"
import {handleProductClick} from "../../../../events"
import {SofaType, SummaryType} from "../../../../config/constants"

interface ColourwayImageSlideProps extends SlideDetail {
    children?: ReactNode
    singleTile?: boolean
    numberOfSlides?: number
    index?: number
    isActiveSlide: boolean
    summaryType: SummaryType
    firstItemNumber?: string
}

export const ColourwayImageSlide: FC<ColourwayImageSlideProps> = ({
    id,
    imageUrl,
    linkUrl,
    tooltipTitle,
    children,
    singleTile,
    isActiveSlide,
    textTitle,
    price,
    colour,
    currencyCode,
    department,
    summaryType,
    firstItemNumber,
    brand,
    client,
}) => {
    return (
        <TileCardMedia
            $isPositionAbsolute={singleTile}
            // title={tooltipTitle}
            component="a"
            href={linkUrl.toLowerCase()}
            onClick={() => {
                handleProductClick({
                    id,
                    title: textTitle,
                    price,
                    colour,
                    currencyCode,
                    department,
                    firstItemNumber,
                    brand,
                    client,
                })
            }}
            tabIndex={isActiveSlide ? 0 : -1}
            data-testid="product_summary_image_media"
            className={summaryType === SofaType ? "sofa-background" : ""}
        >
            <TileImage
                imageUrl={imageUrl}
                alt={tooltipTitle}
                testid={formatTextTestIds(`product_summary_image_${id}`)}
            />
            {children}
        </TileCardMedia>
    )
}
